export default __webpack_public_path__ + "478101852cef9bb11ee4e450d5f70dc8.svg";